const priceValues = (rentTotalPrice, {
  priceMin, priceMax, rentalTotalPriceMin, rentalTotalPriceMax,
}) => ({
  min: rentTotalPrice ? rentalTotalPriceMin : priceMin,
  max: rentTotalPrice ? rentalTotalPriceMax : priceMax,
})

const priceFieldsMapper = (rentTotalPrice, { max, min }) => {
  const pricesWithCondo = {
    rentalTotalPriceMax: max,
    rentalTotalPriceMin: min,
    priceMin: null,
    priceMax: null,
  }

  const pricesWithoutCondo = {
    priceMax: max,
    priceMin: min,
    rentalTotalPriceMax: null,
    rentalTotalPriceMin: null,
  }

  return rentTotalPrice ? pricesWithCondo : pricesWithoutCondo
}

export {
  priceValues,
  priceFieldsMapper,
}
